/* treats.js  -  THE ONE LIST OF TREATS AND THEIR CALORIES.

   EVERY SURFACE THAT COUNTS A TREAT READS THIS FILE AND NOTHING ELSE.
   Today that is /pages/picky-eater-guide and /pages/treat-calculator. Change a
   number here and both change on the next page load.

   DO NOT COPY THESE FIGURES INTO A PAGE. That is what this file exists to stop.
   A page that carries its own list will drift from this one silently, which is
   exactly what happened before it was written.

   kcal are per piece, as fed, from the label ME.
   Loaded classic or deferred before the page's own script; both pages check for
   window.wynTreats and hide their ledger if it is missing rather than guessing.
*/
window.wynTreats = {
  v: 1,
  updated: "2026-09-03",

  /* the ceiling, as a percentage of the dog's day */
  treat_pct: 10,

  /* ours */
  ours: [
    { id: "liver",   name: "Beef liver bites", kcal: 1.6,  unit_one: "liver bite",   unit_many: "liver bites" },
    { id: "beef",    name: "Beef strips",      kcal: 18,   unit_one: "beef strip",   unit_many: "beef strips" },
    { id: "chicken", name: "Chicken strips",   kcal: 19.4, unit_one: "chicken strip", unit_many: "chicken strips" }
  ],

  /* everything else people actually hand a dog */
  common: [
    { id: "x1",  name: "Cheese, one slice",                kcal: 110 },
    { id: "x2",  name: "Deli meat, one slice",             kcal: 30 },
    { id: "x3",  name: "Peanut butter, one tablespoon",    kcal: 95 },
    { id: "x4",  name: "Dog biscuit, medium",              kcal: 40 },
    { id: "x5",  name: "Dental chew, medium",              kcal: 80 },
    { id: "x6",  name: "Bully stick, six inch",            kcal: 90 },
    { id: "x7",  name: "Training treat, small",            kcal: 4 },
    { id: "x8",  name: "Cooked chicken or beef, one ounce", kcal: 45 },
    { id: "x9",  name: "Hot dog, one",                     kcal: 150 },
    { id: "x10", name: "Bacon, one slice",                 kcal: 45 },
    { id: "x11", name: "Egg, one",                         kcal: 75 },
    { id: "x12", name: "Baby carrot",                      kcal: 4 }
  ]
};